import {
  Activity,
  ArrowLeftRight,
  Bot,
  ChartCandlestick,
  Grid3x3,
  History,
  KeyRound,
  LucideIcon,
  Radio,
  Split,
  UserPlus,
} from "lucide-react";
import { UsageType } from "@shared/types";

/** Lucide icons for the plan usage types (new look). */
export const USAGE_TYPE_TO_LUCIDE_ICON: { [key in UsageType]?: LucideIcon } = {
  [UsageType.ACTIVE_TRADE]: Activity,
  [UsageType.MANUAL_TRADE]: ArrowLeftRight,
  [UsageType.CLIENT]: KeyRound,
  [UsageType.DCA_BOT]: Bot,
  [UsageType.GRID_BOT]: Grid3x3,
  [UsageType.TV_BOT]: ChartCandlestick,
  [UsageType.SIGNAL_BOT]: Radio,
  [UsageType.BACKTESTING]: History,
  [UsageType.HEDGING_BOT]: Split,
  [UsageType.SECURE_CLIENT_INVITE]: UserPlus,
};
